import React, { useRef } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { SplitButton } from 'primereact/splitbutton';
import { Button } from 'primereact/button';
import { OverlayPanel } from 'primereact/overlaypanel';

import { caseNoteCallLogFilterOptions } from 'constants/dropdownOptions';
import { useUserDetailsContext } from 'context/userDetailsContext';
import constants from 'constants/index';
import TextSnippetWrapper from 'components/TextSnippetWrapper';
import useCaseNoteDownload from 'hooks/useCaseNoteDownload';

export default function Filter({ setShow, filterOnChange, filter, hasCompanion, caseDetails }) {
  const { getPermission } = useUserDetailsContext();
  const { downloadCaseNotesAsPDF } = useCaseNoteDownload();
  const printOverlayRef = useRef(null);

  const handlePrintPDF = (downloadType = 'case_note') => {
    if (caseDetails?.case_id) {
      downloadCaseNotesAsPDF(caseDetails.case_id, {
        case_name: caseDetails?.case_description?.case_name,
        download_type: downloadType,
      });
    }
  };

  return (
    <div className="row mb-4">
      <div className="col-sm-12 d-flex justify-content-between align-items-center flex-wrap gap-2">
        <div className="d-flex align-items-center filter-wrap p-2 filter-wraper">
          <div className="d-flex align-items-center autowidth mb-3 mb-lg-0">
            <div className="autowidth">
              <span className="p-input-icon-left input-shadow autowidth">
                <i className="icon-search F-size16 cursor-pointer" />
                <TextSnippetWrapper
                  type="text"
                  placeholder="Search"
                  value={filter?.keyword}
                  onChange={filterOnChange}
                  className="input-search"
                  name="keyword"
                  autoComplete="off"
                />
              </span>
            </div>
          </div>

          <div className="note-filter ms-lg-4 autowidth">
            <span className="text-bold black-600 me-2">Filters: </span>
            <Dropdown
              value={filter?.note_type}
              options={caseNoteCallLogFilterOptions}
              onChange={filterOnChange}
              name="note_type"
              placeholder="By Status"
              className="mx-1"
            />
          </div>
        </div>
        {getPermission('cases') === constants.permissions.WRITE && (
          <div className="d-flex align-items-center gap-2 flex-wrap">
            <Button
              ref={printOverlayRef}
              label="Download"
              className="p-button p-button-primary ml-2 mt-lg-0"
              icon="pi pi-download"
              onClick={(e) => printOverlayRef.current.toggle(e)}
            />
            <OverlayPanel ref={printOverlayRef}>
              <div className="p-0">
                <div className="mb-1">
                  <Button
                    label="All"
                    className="p-button p-button-text p-button-plain  justify-content-start"
                    icon="pi pi-file-pdf"
                    onClick={() => {
                      handlePrintPDF('case_note&call_log');
                      printOverlayRef.current.hide();
                    }}
                  />
                </div>
                <div className="mb-1">
                  <Button
                    label="Case Note"
                    className="p-button p-button-text p-button-plain  justify-content-start"
                    icon="pi pi-file-pdf"
                    onClick={() => {
                      handlePrintPDF('case_note');
                      printOverlayRef.current.hide();
                    }}
                  />
                </div>
                <div>
                  <Button
                    label="Call Log"
                    className="p-button p-button-text p-button-plain  justify-content-start"
                    icon="pi pi-file-pdf"
                    onClick={() => {
                      handlePrintPDF('call_log');
                      printOverlayRef.current.hide();
                    }}
                  />
                </div>
              </div>
            </OverlayPanel>
            {!hasCompanion ? (
              <>
                <Button
                  label="Case Note"
                  className="p-button p-button-primary ml-2 "
                  onClick={() => setShow({ type: 'case_note', companion_link: false })}
                  icon="pi pi-plus"
                />
                <Button
                  label="Call Log"
                  className="p-button p-button-primary ml-2 "
                  onClick={() => setShow({ type: 'call_log', companion_link: false })}
                  icon="pi pi-plus"
                />
              </>
            ) : (
              <>
                <SplitButton
                  label="Case Note"
                  icon="pi pi-plus"
                  onClick={() => setShow({ type: 'case_note', companion_link: false })}
                  className="p-button-primary p-0"
                  model={[
                    {
                      label: 'Add this case note to all companion cases',
                      command: (e) => setShow({ type: 'case_note', companion_link: true }),
                    },
                  ]}
                />
                <SplitButton
                  label="Call Log"
                  icon="pi pi-plus"
                  onClick={() => setShow({ type: 'call_log', companion_link: false })}
                  className="p-button-primary p-0"
                  model={[
                    {
                      label: 'Add this call log to all companion cases',
                      command: (e) => setShow({ type: 'call_log', companion_link: true }),
                    },
                  ]}
                />
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
